import { useT } from '../i18n'
import styles from './Splash.module.css'

/**
 * Shown only while the session is resolving, which is normally one frame. The
 * app mark — three rounded tiles stepping out of the dark — breathing in the
 * accent, on the bare ground.
 */
export function Splash(): JSX.Element {
  const t = useT()

  return (
    <div className={styles.splash} role="status" aria-label={t.common.loading}>
      <div className={styles.mark} aria-hidden="true">
        <span className={styles.tile} />
        <span className={styles.tile} />
        <span className={styles.tile} />
      </div>
    </div>
  )
}
